export default __webpack_public_path__ + "static/media/img-22.22eb453f.jpg";